document.addEventListener('click', function (e) {
  var trigger = e.target.closest('[data-open-membership-comparison]');
  if (!trigger) return;
  e.preventDefault();
  var dialog = document.getElementById('membership-comparison-dialog');
  if (!dialog) return;
  dialog.showModal();
  document.body.style.overflow = 'hidden';
  requestAnimationFrame(function () {
    requestAnimationFrame(function () {
      dialog.classList.add('is-open');
    });
  });
});

document.addEventListener('DOMContentLoaded', function () {
  var dialog = document.getElementById('membership-comparison-dialog');
  if (!dialog) return;

  function closeDialog() {
    dialog.classList.remove('is-open');
    document.body.style.overflow = '';
    setTimeout(function () {
      dialog.close();
    }, 350);
  }

  dialog.addEventListener('click', function (e) {
    if (e.target === dialog) closeDialog();
  });

  var closeBtn = dialog.querySelector('.js-mc-dialog-close');
  if (closeBtn) {
    closeBtn.addEventListener('click', closeDialog);
  }

  dialog.addEventListener('cancel', function (e) {
    e.preventDefault();
    closeDialog();
  });

  var desktopMq = window.matchMedia('(min-width: 992px)');
  desktopMq.addEventListener('change', function (e) {
    if (e.matches && dialog.open) {
      dialog.classList.remove('is-open');
      document.body.style.overflow = '';
      dialog.close();
    }
  });
});
